import classNames from "classnames";
import { NumberInput } from "../../../components/numberInput/numberInput";
import { Input } from "../../../components/input/input";

import styles from "./addKpiTask.module.css";

import { Text } from "../../../components/text/text";

export const InputBlock = ({ type, title, value, setValue, className, min, max, error }) => {
    return (
        <div className={classNames(styles.input_block, className)}>
            <Text as="div" variant="caption" className={styles.input_block_title} size={14}>
                {title}
            </Text>
            {type === "number" && <NumberInput error={error} val={value} setVal={setValue} min={min} max={max} />}
            {type !== "number" && type !== "user" && <Input error={error} type={type} value={value} setValue={setValue} />}
        </div>
    )
}
